import createReactComponent from '../createReactComponent';
export default createReactComponent('two', 'Two', [["path",{"d":"M8.75 9.92c0-3.894 5.77-3.894 5.77 0 0 2.94-3.77 5.476-5.77 7.08 0 0 3.75-.625 6.25 0","key":"svg-0"}]]);